import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, ControlLabel, HelpBlock, FormControl, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Input = ({ horizontal, icon, required, input, label, type, help, labelCol = 2, valueCol = 10, meta: { touched, error, warning }, success, action, addon, formGroupStyle, formGroupClass, trimOnBlur, children, ...props }) => {
	const validationState = touched && (error && 'error') || (warning && 'warning') || (success && 'success') || null;

	const handleBlur = trimOnBlur
		? (e) => {
			const raw = input.value;
			if (typeof raw === 'string' && raw.trim() !== raw) {
				input.onBlur(raw.trim());   // redux-form commits the passed value; passing the event would re-commit the untrimmed e.target.value
			} else {
				input.onBlur(e);
			}
		}
		: input.onBlur;

	let formControl = <FormControl {...input} onBlur={handleBlur} type={type} {...props}>{children}</FormControl>;
	if (icon) {
		formControl = <span className='input-icon'>{formControl}<FontAwesomeIcon icon={icon} /></span>;
	}
	if (action) {
		formControl = <InputGroup>
			{formControl}
			<InputGroup.Button>{action}</InputGroup.Button>
		</InputGroup>;
	}
	if (addon) {
		formControl = <InputGroup>
			{formControl}
			<InputGroup.Addon>{addon}</InputGroup.Addon>
		</InputGroup>;
	}

	const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
	const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
	const labelHint = required && <em className='required_s'>*</em>;

	if (horizontal) {
		return (
			<FormGroup validationState={validationState} style={formGroupStyle} className={formGroupClass}>
				{labelCol > 0 && <Col componentClass={ControlLabel} sm={labelCol}>
					{label}{labelHint}
				</Col>}
				<Col sm={valueCol}>
					{formControl}
					{errorBlock}
					{helpBlock}
				</Col>
			</FormGroup>);
	}

	return (
		<FormGroup validationState={validationState} style={formGroupStyle} className={formGroupClass}>
			{label && <ControlLabel>{label}{labelHint}</ControlLabel>}
			{formControl}
			{errorBlock}
			{helpBlock}
		</FormGroup>
	);
};

Input.propTypes = {
	horizontal: PropTypes.bool,
	input: PropTypes.object,
	label: PropTypes.string,
	type: PropTypes.string,
	help: PropTypes.string,
	meta: PropTypes.object,
	placeholder: PropTypes.string,
	disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	componentClass: PropTypes.string,
	value: PropTypes.string,
	icon: PropTypes.string,
};

export default Input;